import * as apiTo from '../api'
// Components
import LmEntityActions from '@components/ag-grid-helpers/EntityActions'
import AgGridGroupOptions from './AgGridGroupOptions'
import LmGridEntityLink from '@components/ag-grid-helpers/EntityLink'

function getYesNoFilterConfig(hasIntermediate = false) {
  return {
    filter: 'AgGridYesNoFilter',
    floatingFilterComponent: 'AgGridYesNoFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      hasIntermediate,
      filterChanged: filterModel => {
        const gridOptions = this.$refs.agGrid.getGridOptions()
        gridOptions.api.setFilterModel(filterModel)
      }
    }
  }
}

function getSimpleColDef(col) {
  return {
    headerName: col.name,
    field: col.slug,
    hide: !col.preselected
  }
}

function getDoiColDef(col) {
  return {
    ...getSimpleColDef(col),
    cellRendererParams: params => {
      if (!params.data) return
      if (!params || !params.value) return
      return {
        customData: {
          id: params.data.id,
          routeName: 'article-show',
          label: params.value,
          newTab: false
        }
      }
    },
    cellRendererFramework: LmGridEntityLink
  }
}

function getInputSourceColDef(col) {
  return {
    ...getSimpleColDef(col),
    ...getYesNoFilterConfig.call(this),
    cellStyle: { textAlign: 'center' },
    cellRenderer: params => (params.value ? '✔' : '')
  }
}

function getApprovedColDef(col) {
  return {
    ...getSimpleColDef(col),
    ...getYesNoFilterConfig.call(this, true),
    cellStyle: { textAlign: 'center' },
    minWidth: 150,
    cellRendererParams: params => ({
      value: params.value,
      options: [
        { label: 'Yes', value: true, color: 'green' },
        { label: 'Idk', value: null, color: 'tertiary' },
        { label: 'No', value: false, color: 'darkblue' }
      ],
      valueChanged: (newVal, { id }, params) => {
        apiTo.updateArticle(id, newVal).then(() => {
          this.$emit('refresh-stats')
          params.setValue(newVal)
        })
      }
    }),
    cellRendererFramework: AgGridGroupOptions
  }
}

function getColDefWithNA(col) {
  return {
    ...getSimpleColDef(col),
    cellRenderer: params => params.value || 'N/A'
  }
}

const isInputSource = col => ['input_source_member', 'input_source_publisher'].includes(col)
const isColWithNA = col => ['publisher_name', 'article_name', 'publication_year'].includes(col)

export function getColDefs(cols) {
  const columnDefs = []
  const addColDef = (col, colDefFn) => columnDefs.splice(col.order_column - 1, 0, colDefFn(col))

  for (const col of cols) {
    if (col.slug === 'doi') addColDef(col, getDoiColDef)
    else if (isColWithNA(col.slug)) addColDef(col, getColDefWithNA)
    else if (isInputSource(col.slug)) addColDef(col, getInputSourceColDef.bind(this))
    else if (col.slug === 'is_approved') addColDef(col, getApprovedColDef.bind(this))
    else addColDef(col, getSimpleColDef)
  }

  columnDefs.push({
    headerName: '',
    filter: false,
    width: 80,
    cellRendererFramework: LmEntityActions,
    lockVisible: true
  })

  return columnDefs
}
